import { render } from "./Service.vue?vue&type=template&id=689904c0&scoped=true"
const script = {}

import "./Service.vue?vue&type=style&index=0&id=689904c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689904c0"]])

export default __exports__